export default {
  data() {
    return {
      headers: [
        { text: 'Тип', align: 'left', value: 'type', class: 'th th--type' },
        { text: 'Дата создания', align: 'right', value: 'created_at', class: 'th th--date' },
        { text: 'Сумма', align: 'right', value: 'amount', class: 'th th--amount' },
        { text: 'Название', align: 'right', value: 'title', class: 'th th--title' },
      ],
      rowsPerPageItems: [
        50, 100, 250, { text: 'Весь список', value: -1 },
      ],
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    loading() {
      return this.$store.state.loading;
    },
    transactions() {
      return this.$store.state.userTransactions;
    },
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
  },
  methods: {
    getTypeLabel(type) {
      return type === 'in'
        ? { label: 'Входящая', shortLabel: 'Вход', color: 'green' }
        : { label: 'Исходящая', shortLabel: 'Исх', color: 'red' };
    },
  },
  mounted() {
    this.$store.dispatch('GetProfile');
    this.$store.dispatch('GetTransactions');
  },
};
